import React from 'react';

import styled from 'styled-components';

import {LazyTooltip} from 'app/components/general/LazyTooltip';
import {gt} from 'app/utils/i18n';
interface HotlinkWarningProps {
  src: string;
}

export function HotlinkWarning({src}: HotlinkWarningProps): JSX.Element {
  return (
    <LazyTooltip
      tooltip={gt(
        'This image is hosted externally and can’t be displayed here. Please copy the link, download the image, and upload it directly to SweetProcess.'
      )}
      placement="top"
    >
      <StyledHeaderDiv className="w-100 bg-white position-absolute d-flex justify-content-between p-1 align-items-center">
        <StyledLinkContainerDiv className="overflow-hidden text-nowrap text-truncate">
          <small>
            <a href={src} target="_blank" rel="noopener noreferrer" title={src}>
              {src}
            </a>
          </small>
        </StyledLinkContainerDiv>

        <i className="fas fa-exclamation-triangle text-warning" />
      </StyledHeaderDiv>
    </LazyTooltip>
  );
}

const StyledHeaderDiv = styled.div`
  top: 0px;
`;

const StyledLinkContainerDiv = styled.div`
  max-width: calc(100% - 35px);
`;
